export default __webpack_public_path__ + "static/media/ISEO CLASS-2 EXAM PATTERN 2025.548cb146.pdf";